/**
 * YD Header Navigation JS
 * - 音乐播放控制 + 波浪动画
 */
(function() {
  'use strict';

  const WAVE_PERIOD = 8; // 波浪周期 (像素)
  let waveTimeline = null;

  function initMusicToggle() {
    const musicToggle = document.getElementById('music-toggle');
    const bgMusic = document.getElementById('bgm-audio');
    const wavePath = document.getElementById('music-wave-path');

    if (!musicToggle || !bgMusic) {

      return;
    }

    /**
     * 启动波浪动画
     */
    function startWaveAnimation() {
      if (!wavePath || typeof gsap === 'undefined') return;

      if (waveTimeline) waveTimeline.kill();

      gsap.set(wavePath, { x: 0 });
      waveTimeline = gsap.to(wavePath, {
        x: WAVE_PERIOD,
        duration: 0.6,
        ease: 'none',
        repeat: -1
      });
    }

    /**
     * 停止波浪动画
     */
    function stopWaveAnimation() {
      if (!wavePath || typeof gsap === 'undefined') return;

      if (waveTimeline) {
        waveTimeline.kill();
        waveTimeline = null;
      }
      // 先清理 wavePath 上可能残留的 tween，防止叠加
      gsap.killTweensOf(wavePath);
      gsap.to(wavePath, { x: 0, duration: 0.3 });
    }

    /**
     * 更新 UI 状态
     */
    function updateUI(isPlaying) {
      if (isPlaying) {
        musicToggle.classList.add('playing');
        startWaveAnimation();
      } else {
        musicToggle.classList.remove('playing');
        stopWaveAnimation();
      }
    }

    // 监听音频播放状态
    bgMusic.addEventListener('play', () => updateUI(true));
    bgMusic.addEventListener('pause', () => updateUI(false));

    // 点击切换播放/暂停
    musicToggle.addEventListener('click', (e) => {
      e.stopPropagation();

      // 与 AudioManager 集成
      if (window.AudioManager) {
        window.AudioManager.toggle();
      } else {
        // 独立模式
        if (bgMusic.paused) {
          bgMusic.volume = 0.5;
          bgMusic.play().then(() => {

          }).catch(err => {

          });
        } else {
          bgMusic.pause();

        }
      }
    });

    // 初始状态检查
    if (!bgMusic.paused) {
      updateUI(true);
    }

  }

  // 等待 DOM 和 GSAP 加载
  function init() {
    if (typeof gsap === 'undefined') {
      let retries = 0;
      const maxRetries = 50; // 最多 5 秒
      const checkGSAP = setInterval(() => {
        if (typeof gsap !== 'undefined') {
          clearInterval(checkGSAP);
          initMusicToggle();
        } else if (++retries >= maxRetries) {
          clearInterval(checkGSAP);
          console.warn('[HeaderNav] GSAP not loaded after 5s');
        }
      }, 100);
    } else {
      initMusicToggle();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
